<div class="row">
  <div class="col no-padding" size="12">
    <app-mot-signed-vacations-list [signedVacations]="signedVacations"> </app-mot-signed-vacations-list>
    <app-mot-feedback-msg *ngIf="!signedVacations.length" [type]="feedbackTypes.EMPTY_RESULT">
      <p class="c-feedback-msg__text">{{ 'EMPLOYEE_PORTAL.NO_SIGNED_TIMETABLES_IN_PERIOD' | translate }}</p>
    </app-mot-feedback-msg>
  </div>
</div>
